import { render, staticRenderFns } from "./BrowserNavigationPager.vue?vue&type=template&id=7fe2432a"
import script from "./BrowserNavigationPager.vue?vue&type=script&lang=js"
export * from "./BrowserNavigationPager.vue?vue&type=script&lang=js"
import style0 from "./BrowserNavigationPager.vue?vue&type=style&index=0&id=7fe2432a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports